export default __webpack_public_path__ + "static/dina-80e930c28e40f04660a9a6a2ae495e6e.png";